import { z } from "zod";

import { effectBuildSchema } from "../shared/index.ts";

const effectPropertiesSchema = effectBuildSchema.omit({ id: true });

export type EffectProperties = z.infer<typeof effectPropertiesSchema>;

const effectsByIdSchema = z.record(effectPropertiesSchema);

export type EffectsByIdState = z.infer<typeof effectsByIdSchema>;

export const effectDesignsStateSchema = z.object({
  byId: effectsByIdSchema,
  idsByResponseId: z.record(z.array(z.number().int())),
  responseIdByEffectId: z.record(z.number().int()),
});

export type EffectDesignsState = z.infer<typeof effectDesignsStateSchema>;
